import { SIGNUP_URL } from "./app";
import { LOOP_TM, type Copy } from "./types";

export type NavItem = {
  readonly id: string;
  readonly href: string;
  readonly kind: "anchor" | "route";
  readonly label: Copy;
};

export const HOME_PATH = "/";

export const PRIMARY_CTA_HREF = "/start";

export const KNITTING_PATH = "/3d-knitting";

// The load balancer serves /legal/* from the shared v3d-public-files bucket on
// every environment's own host, so same-origin links resolve correctly in dev,
// staging and production alike. `npm run dev` has no load balancer in front of
// it, so fall back to the production origin there.
export const LEGAL_ORIGIN = import.meta.env.DEV ? "https://loop.variant3d.io" : "";

export const TERMS_URL = `${LEGAL_ORIGIN}/legal/terms`;

export const PRIVACY_URL = `${LEGAL_ORIGIN}/legal/privacy`;

export const NAV_ITEMS: readonly NavItem[] = [
  { id: "how", href: "#how", kind: "anchor", label: LOOP_TM },
  { id: "applications", href: "#applications", kind: "anchor", label: ["Applications"] },
  { id: "platform", href: "#platform", kind: "anchor", label: ["Platform"] },
  { id: "knitting", href: KNITTING_PATH, kind: "route", label: ["3D knitting"] },
];

export const NAV_ACTIONS = [
  { label: "See plans", href: "/start", variant: "ghost" },
  { label: "Create for free", href: SIGNUP_URL, variant: "brand" },
] as const;

export const SCROLL_SPY_IDS: readonly string[] = NAV_ITEMS.filter((item) => item.kind === "anchor").map(
  (item) => item.id,
);

export const resolveAnchor = (href: string, isHome: boolean): string =>
  href.startsWith("#") && !isHome ? `${HOME_PATH}${href}` : href;

export const SKIP_LINK_LABEL = "Skip to content";

export const BRAND_LABEL = "VARIANT3D — home";
